// extracted by mini-css-extract-plugin
export default {"SocialButtons":"styles_SocialButtons__R8mt9","buttons":"styles_buttons__IOchP"};